import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import useCopayScheduleStep from "./hooks/useCopayScheduleStep";

const CopayScheduleStep = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
  setFalg,
  intialSchedule,
  paramsDesc,
  sourceData,
  scheduleDesc,
  onNavigate,
}) => {
  const copayScheduleStepData = useCopayScheduleStep(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData,
    setFalg,
    intialSchedule,
    paramsDesc,
    sourceData,
    scheduleDesc,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={copayScheduleStepData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {copayScheduleStepData.screen_title} -{" "}
          <span className="heading-cod">
            {copayScheduleStepData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={copayScheduleStepData.formFields}
        dropdownValues={copayScheduleStepData.dropdownValues}
        paramsData={copayScheduleStepData.paramsData}
        updataParamData={copayScheduleStepData.updateParamData}
      />
      <ButtonsSection ctaButtons={copayScheduleStepData.ctaButtons} />
      <DisplayTable
        data={copayScheduleStepData.data}
        parmKey={copayScheduleStepData.parmKey}
        menuOptions={copayScheduleStepData.menuOptions}
        tableHeaders={copayScheduleStepData.columnDef}
        setRowData={copayScheduleStepData.setRowData}
        selectedPriceSchedules={copayScheduleStepData.selectedRows}
        setSelectedPriceSchedules={copayScheduleStepData.setSelectedRows}
        selectMode={copayScheduleStepData.selectMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={copayScheduleStepData.first}
          rows={copayScheduleStepData.rows}
          totalRecords={copayScheduleStepData.totalRecords}
          currentPage={copayScheduleStepData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={copayScheduleStepData.onPageChange}
        />
      </div>
      {copayScheduleStepData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={copayScheduleStepData.isConfirmationModalOpen}
          onRequestClose={copayScheduleStepData.closeConfirmationModal}
          onBack={copayScheduleStepData.closeConfirmationModal}
          onSave={copayScheduleStepData.deleteCopayScheduleStep}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={copayScheduleStepData.setSelectedOption}
        />
      )}
    </div>
  );
};
export default CopayScheduleStep;
